import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1aea083a")

_pushScopeId("data-v-1aea083a")
const _hoisted_1 = { class: "invite-people" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('invitePeople.description')), 1),
    _createVNode(_component_Input, {
      id: "copy",
      type: "copy",
      modelValue: _ctx.link
    }, null, 8, ["modelValue"])
  ]))
})